import React from 'react';
import PropTypes from 'prop-types';
import { TextField } from '@material-ui/core';

/**
 * @typedef {import('@material-ui/core').TextFieldProps} TextFieldProps
 * @typedef {{ onChange: Function, inputRef?: React.Ref<any> }} InputProps
 */

/** @type {(props: TextFieldProps | InputProps) => JSX.Element} */
const Input = ({ onChange, inputRef, ...props }) => (
  <TextField fullWidth onChange={(e) => onChange(e.target.value)} inputRef={inputRef} {...props} />
);

Input.propTypes = {
  onChange: PropTypes.func,
  inputRef: PropTypes.oneOfType([
    PropTypes.shape(null),
    PropTypes.shape({
      current: PropTypes.node,
    }),
  ]),
};

Input.defaultProps = {
  onChange: () => {},
};

export default Input;
